export const basket = {
  namespaced: true,
  state: {
    assets: [],
    downloadFormats: [],
    selectedFormat: '',
    downloadUrl: '',
    modalVisible: false
  },
  mutations: {
    setSelectedFormat: (state, format) => {
      state.selectedFormat = format;
    },
    setFormats: (state, formats) => {
      state.downloadFormats = formats;
    },
    setDownloadUrl: (state, downloadUrl) => {
      state.downloadUrl = downloadUrl;
    },
    add: (state, asset) => {
      state.assets.push(asset);
    },
    remove: (state, asset) => {
      const index = state.assets.indexOf(asset);
      if (index !== -1) {
        state.assets.splice(index, 1);
      }
    },
    empty: (state) => {
      state.assets = [];
    },
    SHOW_BASKET: (state, value) => {
      state.modalVisible = value;
    }

  },
  getters: {
    assetCount: (state) => {
      return state.assets.length;
    },
    assets: (state) => {
      return state.assets;
    },
    formats: (state) => {
      return state.downloadFormats;
    },
    downloadUrl: (state) => {
      return state.downloadUrl;
    },
    selectedFormat: (state) => {
      return state.selectedFormat;
    },
    inBasket: state => assetItem => {
      return state.assets.indexOf(assetItem) !== -1
    }
  },
  actions: {
    selectedFormat: (context, format) => {
      context.commit('setSelectedFormat', format);
    },
    add: (context, asset) => {
      context.commit('add', asset);
    },
    remove: (context, asset) => {
      context.commit('remove', asset);
    },
    removeAll: (context) => {
      context.commit('empty');
    },
    // loadFormats: (context) => {
    //   if (context.state.assetIds.length > 0) {
    //     axios.post(context.rootState.config.server + 'api/formats/', context.state.assetIds).then(
    //         function (response) {
    //           context.commit('setFormats', response.data);
    //           context.commit('setSelectedFormat', response.data[0]);
    //         })
    //   }
    // },
    // download: (context) => {
    //   // const data = {assetIds: context.state.assetIds, downloadFormatId: 1};
    //   // axios.post(context.rootState.config.server + 'api/prepareDownload/', data).then(
    //   //     function (response) {
    //   //       context.commit('setDownloadUrl', context.rootState.config.server + 'api/download/' + response.data.uuid)
    //   //     }
    //   // );
    // }
  }
};
